import AccountGroupRow from "./AccountGroupRow.js";
import AccountIntervalGroupRow from "./AccountIntervalGroupRow.js";
import AccountRow from "./AccountRow.js";
import FormulaRow from "./FormulaRow.js";
import GeneratedAccountGroupRow from "./GeneratedAccountGroupRow.js";
import GeneratedAccountRow from "./GeneratedAccountRow.js";
import GroupRow from "./GroupRow.js";
import KeyFigureRow from "./KeyFigureRow.js";
import ModelFactory from "../../../ModelFactory.js";
import PreliminaryResultRow from "./PreliminaryResultRow.js";
import RepeatingRow from "./RepeatingRow.js";
import SpacerRow from "./SpacerRow.js";
import StaticReportRow from "./StaticReportRow.js";
import TextRow from "./TextRow.js";

/**
 * TODO: write documentation
 */
class ReportRowFactory extends ModelFactory {
	allClasses() {
		return [
			AccountGroupRow,
			AccountIntervalGroupRow,
			FormulaRow,
			AccountRow,
			GroupRow,
			GeneratedAccountGroupRow,
			GeneratedAccountRow,
			KeyFigureRow,
			PreliminaryResultRow,
			RepeatingRow,
			SpacerRow,
			StaticReportRow,
			TextRow,
		];
	}

	allItemClasses() {
		return this.allClasses().filter((klass) => klass.isVisible());
	}

	_getTypeFromJson(json) {
		return json.rowType;
	}

	/**
	 * GroupRow and AccountGroupRow are both serialized and persisted as
	 * "CompositeRow". They differ (in terms of the JSON data) with the
	 * accountGroup property that AccountGroupRow has but GroupRow doesn't.
	 */
	_findClassFromJson(json) {
		const type = this._getTypeFromJson(json);

		if (type === "CompositeRow") {
			return this._findCompositeRowClassFromJson(json);
		}

		return this._findClassFromType(type);
	}

	_findCompositeRowClassFromJson(json) {
		if (json.accountGroup) {
			return AccountGroupRow;
		}

		return GroupRow;
	}
}

const reportRowFactory = new ReportRowFactory();

export default reportRowFactory;
